import {confirmResetPassword} from "aws-amplify/auth"

export default async function changePassword(formData) {
    try {
        return await confirmResetPassword({username: formData.email, confirmationCode: formData.code, newPassword: formData.newPassword})
    } catch (error) {
        console.error("changePassword: ", error)
    }
}